import React from 'react';
import 'intersection-observer';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { Router, withRouter, Switch, Route } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Integrations } from '@sentry/tracing';
import * as Sentry from '@sentry/react';
import smoothscroll from 'smoothscroll-polyfill';
// eslint-disable-next-line import/no-unresolved
import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { fas } from '@fortawesome/pro-solid-svg-icons';
import configureStore from 'state';
import Routes from 'routing';
import history from 'routing/history';
import { decodeJWT } from 'auth';
import Footer from 'components/Footer';
import Navigation from 'components/Navigation';
import ErrorPage from 'components/Error';
import {
  WaterfallLoadingProvider,
  WaterfallLoadingHider
} from 'components/WaterfallLoader';
import ParallaxProvider from 'components/ParallaxWrapperFiber/ParallaxProvider';
import nomadInsuranceTheme from 'products/nomad_insurance/style/theme';
import ukraineTheme from 'products/global/views/Ukraine/style/theme';
import GlobalStyle from 'style/globalStyle';
import baseTheme from 'style/theme';
import { init as initApm } from '@elastic/apm-rum';
import Auth from 'components/Auth';

smoothscroll.polyfill();

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://bad199644c234084ba6ccb3519ccb1f4@o479420.ingest.sentry.io/5524288',
    integrations: [new Integrations.BrowserTracing()],
    environment: process.env.REACT_APP_ENVIRONMENT,
    tracesSampleRate: 1.0,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    beforeSend(event) {
      const userId = decodeJWT('userID');
      if (!event?.user?.id && userId) {
        event.user = { id: userId };
      }
      return event;
    }
  });
}

if (process.env.NODE_ENV !== 'development') {
  initApm({
    serviceName: 'safetywing-frontend',
    serverUrl: 'https://safetywing.apm.europe-west1.gcp.cloud.es.io',
    serviceVersion: '',
    environment: process.env.REACT_APP_ENVIRONMENT
  });
}

const store = configureStore();

library.add(far, fas);

const Theme = withRouter(({ location, children }) => {
  let theme;

  if (
    location.pathname.startsWith('/nomad-insurance') ||
    location.pathname.startsWith('/nomads')
  ) {
    theme = nomadInsuranceTheme;
  } else if (location.pathname.startsWith('/ukraine')) {
    theme = ukraineTheme;
  } else {
    theme = baseTheme;
  }

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
});

const App = () => {
  return (
    <WaterfallLoadingProvider>
      <Provider store={store}>
        <Auth>
          <Router history={history}>
            <Theme>
              <GlobalStyle />
              <ParallaxProvider>
                <Sentry.ErrorBoundary fallback={ErrorPage}>
                  <Navigation />
                  <Routes />
                  <Switch>
                    <Route path="*">
                      <Footer />
                    </Route>
                  </Switch>
                  <div id="modal-portal" />
                </Sentry.ErrorBoundary>
                <WaterfallLoadingHider />
              </ParallaxProvider>
            </Theme>
          </Router>
        </Auth>
      </Provider>
    </WaterfallLoadingProvider>
  );
};

const renderApp = () => render(<App />, document.getElementById('root'));

renderApp();
